import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { StyleSheet } from "@react-pdf/renderer";

import VoTheme from "ui/theme/vocollege2";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
    },
    // wrapper: {
    //   border: `3px solid ${theme.palette.primary.main}`,
    //   borderRadius: theme.shape.borderRadiusBig,
    //   flex: 1,
    //   maxWidth: "100%",
    //   paddingTop: "10%",
    //   position: "relative",
    //   textAlign: "center",
    // },
    // title: {},
    // name: {},
    // personalNumber: {},
    // row: {},
    // signatures: {
    //   display: "flex",
    //   flexDirection: "row",
    //   justifyContent: "center",
    //   paddingLeft: VoTheme.spacing(7),
    //   paddingRight: VoTheme.spacing(7),
    //   width: "100%",
    // },
    // signature: {
    //   borderTop: `1px solid ${VoTheme.palette.common.black}`,
    //   flex: 1,
    //   marginLeft: VoTheme.spacing(1),
    //   marginRight: VoTheme.spacing(1),
    //   maxWidth: 250,
    // },
    // signaturePerson: {},
    // signatureTitle: {},
    // footer: {
    //   border: "1px solid red",
    //   bottom: 0,
    //   left: 0,
    //   position: "absolute",
    //   right: 0,
    // },
  })
);

export const styles = StyleSheet.create({
  page: {
    fontFamily: "Lato",
    fontSize: 15,
    padding: `${VoTheme.spacing(3)} ${VoTheme.spacing(4)}`,
  },
  decorWrapper: {
    alignItems: "flex-end",
    bottom: VoTheme.spacing(3),
    display: "flex",
    flexDirection: "row",
    left: -130,
    position: "absolute",
    right: -130,
    top: VoTheme.spacing(3),
  },
  decor: {
    flex: 1,
    // height: "100%",
    // paddingLeft: VoTheme.spacing(5),
    // paddingRight: VoTheme.spacing(5),
    // width: "100%",
  },
  contentWrapper: {
    fontFamily: "Lato",
    height: "100%",
    width: "100%",
  },
  title: {
    // color: VoTheme.palette.grey[500],
    fontSize: 100,
    fontWeight: 100,
    lineHeight: 1.2,
    marginTop: VoTheme.spacing(4),
    textAlign: "center",
    // textTransform: "uppercase",
  },
  subtitle: {
    // color: VoTheme.palette.grey[500],
    fontSize: 32,
    fontWeight: 300,
    // marginTop: VoTheme.spacing(1),
    textAlign: "center",
  },
  text: {
    fontSize: 16,
    fontWeight: 300,
    textAlign: "center",
  },

  dateRow: {
    fontSize: 12,
    fontWeight: 300,
    paddingTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },

  logoWrapper: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    marginTop: VoTheme.spacing(4),
  },
  // region: {
  //   // fontSize: 16,
  //   // textAlign: "center",
  // },
  footer: {
    // marginTop: VoTheme.spacing(15),
    marginBottom: VoTheme.spacing(2),
  },
  uid: {
    bottom: 0,
    position: "absolute",
    right: 0,
  },

  section: {
    marginTop: VoTheme.spacing(2),
  },
  certifiedCollaboration: {
    fontSize: 12,
    fontWeight: 300,
    marginTop: VoTheme.spacing(1),
    textAlign: "center",
  },
});
